<template>
	<div class="insert-enterprise-module">
		<div class="group-msg">
			<div class="module-title">插入企业模块</div>
			<el-form :model="form" ref="form" :inline="true">
				<el-form-item label="AppID" required>
					<el-input
						v-model="form.appid"
						placeholder="请输入AppID"
						style="width: 400px;"
						maxlength="30"
					></el-input>
					<el-button type="primary" class="btn-save" @click="save">保存</el-button>
				</el-form-item>
			</el-form>

			<div v-if="resultMsg" :class="['result-area', resultType]">
				{{ resultMsg }}
			</div>
		</div>
	</div>
</template>

<script>
import { Message } from 'element-ui'

const APPVER = 'v1'

export default {
	data () {
		return {
			form: {
				appid: ''
			},
			resultMsg: '',
			resultType: ''
		}
	},
	methods: {
		async save () {
			const appid = this.form.appid.trim()
			if (!appid) {
				Message.error('请输入AppID')
				return
			}

			this.resultMsg = ''
			this.resultType = ''

			try {
				const res = await this.$store.dispatch('requestPost', {
					url: `/quickorder/ns/${APPVER}/order/tenpayappid/checkOrInsert/${appid}`,
					data: {}
				})
				if (res.result === true) {
					this.resultMsg = `AppID ${appid} 处理成功`
					this.resultType = 'success'
				} else {
					this.resultMsg = `AppID ${appid} 失败`
					this.resultType = 'error'
				}
			} catch (e) {
				this.resultMsg = `AppID ${appid} 调用失败`
				this.resultType = 'error'
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.insert-enterprise-module {
	width: 100%;
	height: 100%;
	.group-msg {
		background: #fff;
		padding: 20px;
		min-height: 100%;
		text-align: left;

		.module-title {
			font-size: 16px;
			font-weight: 600;
			margin-bottom: 20px;
			color: #333;
		}
		.result-area {
			margin-top: 15px;
			padding: 10px;
			border: 1px solid #ddd;
			min-height: 50px;
			white-space: pre-line;
			&.error {
				color: red;
				background: #fff0f0;
			}
			&.success {
				color: green;
				background: #f0fff0;
			}
		}
		.btn-save {
			margin-left: 20px;
		}
	}
}
</style>
